// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'location-solid';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M6.408 5.616c0 1.224 1.008 2.232 2.232 2.232s2.232-1.008 2.232-2.232S9.864 3.384 8.64 3.384 6.408 4.392 6.408 5.616z' />
    <path d='M8.64.576a5.009 5.009 0 0 1 5.04 5.04c0 2.448-3.816 7.92-4.824 9.288-.072.144-.288.144-.36.072l-.072-.072C7.416 13.536 3.6 8.064 3.6 5.616A5.009 5.009 0 0 1 8.64.576z' />
    <path d='M13.104 13.32c2.016.432 3.384 1.08 3.384 1.872 0 1.224-3.528 2.232-7.848 2.232S.792 16.416.792 15.192c0-.792 1.368-1.44 3.384-1.872' />
  </g>
);

export const viewBox = '0 0 18 18';
